// 米問屋（里）：課金「米問屋の通い帳」（永続・komedoiya）を持っていれば、兵糧を掃討チケットに替えられる。
// 兵糧30（オート10戦ぶん）→ 掃討チケット10枚（掃討10戦）で、戦える数は同じ。オートを回す時間の無い人が、あふれる兵糧を使い切れるようにする。
// 米問屋の蔵出しで買った兵糧は替えない（期限の無い掃討チケットにすると、購入から180日の期限が意味をなくす）
import { CONFIG } from './config';
import { grantSweepTickets } from './daily';
import type { OpResult, Profile, Resources } from './profile';
import { boughtStamina, spendStamina, staminaNow } from './stamina';

export const hasKomedoiya = (p: Pick<Profile, 'entitlements'>) => p.entitlements.includes('komedoiya');

/** 今の兵糧と掃討チケットの所持上限から、何回交換できるか */
export function komedoiyaMaxTimes(p: Profile, res: Resources, now: number): number {
  const { hyoro, tickets } = CONFIG.komedoiya;
  const v = staminaNow(p.stamina, now, p);
  const room = CONFIG.sweep.ticketCap - (res.soutou ?? 0);
  return Math.max(0, Math.min(Math.floor((v.value + v.reserve - boughtStamina(v)) / hyoro), Math.floor(room / tickets)));
}

/** 兵糧 hyoro×times → 掃討チケット tickets×times。所持の上限を超える分は替えない（足りなければ 'ticket_cap'） */
export function exchangeKomedoiya(p: Profile, res: Resources, now: number, times: number): OpResult<{ times: number; hyoro: number; tickets: number }> {
  if (!hasKomedoiya(p)) return { ok: false, error: 'komedoiya_required' };
  if (!Number.isSafeInteger(times) || times < 1) return { ok: false, error: 'times' };
  const { hyoro, tickets } = CONFIG.komedoiya;
  if ((res.soutou ?? 0) + tickets * times > CONFIG.sweep.ticketCap) return { ok: false, error: 'ticket_cap' };
  if (!spendStamina(p, now, hyoro * times, { exceptBought: true })) return { ok: false, error: 'hyoro' };
  grantSweepTickets(res, tickets * times);
  return { ok: true, times, hyoro: hyoro * times, tickets: tickets * times };
}
